import React from "react"
import { responsive, colors } from "buoy-theme"
import InformationSection from "./InformationSection"
import styled from "styled-components"

const InformationContainer = styled.div`
  ${responsive("display", "flex", "flex", "none", "none", "none")};
  width: 100%;
  padding: 0 24px 32px;
  flex-wrap: wrap;
  justify-content: space-between;
  border-top: 1px solid ${colors.neutralLightest};
`

export const ProfileInformation = ({
  showReproductiveHistory,
  percentsComplete,
}) =>
  percentsComplete.basicInfo < 100 ||
  percentsComplete.generalHealth < 100 ||
  percentsComplete.medicalHistory < 100 ||
  (showReproductiveHistory && percentsComplete.reproductiveHealth) ? (
    <InformationContainer>
      {percentsComplete.basicInfo < 100 && (
        <InformationSection
          text="Basic Information"
          percent={percentsComplete.basicInfo}
        />
      )}
      {percentsComplete.generalHealth < 100 && (
        <InformationSection
          text="General Health"
          percent={percentsComplete.generalHealth}
        />
      )}
      {percentsComplete.medicalHistory < 100 && (
        <InformationSection
          text="Medical History"
          percent={percentsComplete.medicalHistory}
        />
      )}
      {showReproductiveHistory &&
        percentsComplete.reproductiveHealth < 100 && (
          <InformationSection
            text="Reproductive History"
            percent={percentsComplete.reproductiveHealth}
          />
        )}
    </InformationContainer>
  ) : null



// WEBPACK FOOTER //
// ./assets/common/components/ProfileSwitcher/components/ProfileInformation.js